import { z } from 'zod';

export const createBankAccountSchema = z.object({
  bankName: z.string().min(1),
  accountType: z.enum(['CHECKING', 'CREDIT_CARD', 'SAVINGS']),
  accountMask: z.string().max(4).optional(),
});

export const updateTransactionSchema = z.object({
  categoryId: z.string().optional(),
  merchantName: z.string().optional(),
  isReviewed: z.boolean().optional(),
  flags: z.array(z.object({
    id: z.string(),
    isResolved: z.boolean(),
    resolution: z.string().optional(),
  })).optional(),
});

export const resolveTransactionFlagSchema = z.object({
  resolution: z.string().min(1),
});

export const createCategorySchema = z.object({
  name: z.string().min(1),
  slug: z.string().min(1),
  description: z.string().optional(),
});
